
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function TempoTravelleronrentmumbai() {



    const cardData =
    {
        keyword: ' Tempo Traveller On Rent Mumbai',
        heading: 'Deva Cabs: Tempo Traveller On Rent Mumbai',
        headingDescription: 'Deva Cabs offers reliable, spacious, and hassle-free Tempo Traveller rentals in Mumbai, perfect for group travel, family outings, or corporate trips. Whether you are heading out for a weekend getaway, a wedding event, or an outstation tour, our well-maintained Tempo Travellers provide a comfortable and safe journey for everyone. With options ranging from 9-seater to 26-seater vehicles, we cater to groups of all sizes. Enjoy ample space, push-back seats, and experienced drivers to make your journey smooth and enjoyable with Deva Cabs.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

   "topPlaces": [
    {
      "title": "Marine Drive",
      "location": "Mumbai, Maharashtra",
      "description": "Marine Drive is a 3.6-kilometer-long arc-shaped boulevard that stretches from Nariman Point to Girgaon Chowpatty. Also known as the 'Queen’s Necklace' for its glowing curve of street lights at night, it is a beloved seaside promenade for evening walks, breezy bike rides, and romantic sunsets. The backdrop of art deco buildings and the peaceful sound of waves create a rare urban serenity, making Marine Drive a timeless retreat in the heart of Mumbai."
    },
    {
      "title": "Gateway of India",
      "location": "Mumbai, Maharashtra",
      "description": "Located at the waterfront in Colaba, the Gateway of India is Mumbai’s most iconic monument. Built in 1924 to honor the visit of King George V and Queen Mary, this massive basalt arch combines Indo-Saracenic architecture with colonial flair. Overlooking the Arabian Sea and facing the Taj Mahal Palace Hotel, it serves as a central tourist hub, with ferry rides to Elephanta Caves and local photographers capturing the city’s vibrant pulse. The Gateway is not just a historic landmark—it’s a symbol of Mumbai’s pride and resilience."
    },
    {
      "title": "Elephanta Caves",
      "location": "Elephanta Island, Mumbai Harbour",
      "description": "A UNESCO World Heritage Site, the Elephanta Caves are a complex of ancient Hindu and Buddhist rock-cut temples located on Elephanta Island, about 11 km from Mumbai. These 5th–8th century caves are renowned for their incredible sculptures of Lord Shiva, particularly the 20-foot-high Trimurti—the three-faced form of Shiva representing creation, preservation, and destruction. The island is accessible by ferry from the Gateway of India and offers a tranquil and culturally enriching day trip."
    },
    {
      "title": "Siddhivinayak Temple",
      "location": "Prabhadevi, Mumbai, Maharashtra",
      "description": "The Shree Siddhivinayak Ganapati Mandir is one of Mumbai’s most spiritually significant landmarks, drawing millions of devotees each year. Dedicated to Lord Ganesha, the temple is famous for its beautiful black stone idol with a curved trunk and diamond-studded forehead. Rich in faith, energy, and devotion, the temple also showcases architectural beauty with its carved wooden doors and gold-plated sanctum. Tuesday is considered especially auspicious for darshan, attracting celebrities and commoners alike."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "location": "Mumbai, Maharashtra",
      "description": "A majestic example of Indo-Gothic architecture, Chhatrapati Shivaji Maharaj Terminus is both a UNESCO World Heritage Site and one of India’s busiest railway stations. Designed by British architect F.W. Stevens in 1887, it features elaborate stone carvings, pointed arches, domes, and turrets. The station is a vital part of Mumbai’s daily life while also standing as a living monument to the city’s colonial legacy and artistic grandeur."
    },
    {
      "title": "Juhu Beach",
      "location": "Mumbai, Maharashtra",
      "description": "Juhu Beach is a bustling stretch of sandy coastline in suburban Mumbai, popular for sunsets, local street food, and Bollywood vibes. From joggers and kite-flyers to food stalls selling vada pav, bhel puri, and kulfi, the beach offers a true slice of Mumbai life. Celebrities often frequent nearby luxury homes, and the beach hosts cultural performances and film shoots throughout the year. It's the perfect blend of leisure and local flavor."
    },
    {
      "title": "Haji Ali Dargah",
      "location": "Worli, Mumbai, Maharashtra",
      "description": "Built in the 15th century, the Haji Ali Dargah is a white-domed Indo-Islamic shrine located on an islet off the coast of Worli. The dargah houses the tomb of Sufi saint Haji Ali Shah Bukhari and is accessible via a narrow causeway during low tide. The spiritual calm, rhythmic sea waves, and panoramic sea views create a unique experience for visitors of all faiths. It is one of the most peaceful and scenic religious sites in Mumbai."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "location": "Borivali, Mumbai, Maharashtra",
      "description": "Spread across 104 square kilometers, Sanjay Gandhi National Park is Mumbai’s green oasis and a rare natural reserve within a bustling metropolis. The park is home to leopards, deer, monkeys, and countless bird species. A major highlight is the Kanheri Caves—ancient Buddhist cave carvings over 2,000 years old. With toy train rides, cycling trails, nature walks, and boating, the park is a perfect weekend escape for families, nature lovers, and adventure seekers."
    },
    {
      "title": "Chor Bazaar",
      "location": "Bhendi Bazaar, South Mumbai, Maharashtra",
      "description": "One of the oldest and most legendary flea markets in India, Chor Bazaar is a chaotic maze of shops offering antiques, Bollywood posters, vintage cameras, old clocks, and second-hand furniture. Despite the name (meaning 'Thieves Market'), it's a legal and vibrant place known for unexpected treasures and bargaining fun. Whether you're a collector or a curious explorer, this market is a true reflection of Mumbai’s vibrant street economy and layered history."
    },
    {
      "title": "Girgaon Chowpatty",
      "location": "Girgaon, Mumbai, Maharashtra",
      "description": "Girgaon Chowpatty is a central beach located at the northern end of Marine Drive. Known for its lively ambiance, it becomes a focal point during Ganesh Chaturthi for idol immersions. Food stalls offer classic Mumbai street snacks like pani puri, pav bhaji, and kulfi. Families, couples, and students often gather here to watch the sunset, fly kites, or simply relax by the sea. The beach offers both spiritual and recreational charm right in the heart of the city."
    }
  ],



    "services": [
    {
      "name": "Tempo Traveller on Rent in Mumbai",
      "description": "Deva Cabs offers comfortable and spacious Tempo Travellers on rent in Mumbai, ideal for group travel, family trips, or office outings. Our vehicles are well-maintained, fully AC, and driven by experienced chauffeurs. Whether it’s a day tour or an outstation journey, enjoy ample legroom, luggage space, and smooth ride quality. Book easily with flexible rental durations and competitive pricing."
    },
    {
      "name": "17-Seater Tempo Travellers on Rent in Mumbai",
      "description": "Looking for a 17-seater Tempo Traveller in Mumbai? Deva Cabs provides clean, air-conditioned 17-seaters perfect for weddings, corporate travel, or religious tours. With ample space for passengers and luggage, our vehicles ensure comfort on long journeys. Our courteous drivers, transparent pricing, and punctual service make us a trusted name in group travel solutions."
    },
    {
      "name": "Tempo on Rent Mumbai",
      "description": "Get reliable tempo rental services in Mumbai for all your travel needs. Deva Cabs provides tempo options in various seating capacities with AC and non-AC variants. Whether it’s a picnic, pilgrimage, school tour, or outstation trip — we have a tempo for every occasion. Easy booking, on-time service, and budget-friendly packages included."
    },
    {
      "name": "20 Seater Tempo Travellers on Rent in Mumbai",
      "description": "Travel in comfort with Deva Cabs’ 20-seater Tempo Travellers available in Mumbai. Designed for large groups, our vehicles offer push-back seats, clean interiors, and professional drivers. Ideal for long-distance travel, events, or large family functions, our 20-seater options provide reliable, affordable transport with door-to-door service."
    },
    {
      "name": "Hire Tempo Traveller in Mumbai",
      "description": "Deva Cabs makes it easy to hire a Tempo Traveller in Mumbai with just a call or click. Choose from multiple seating configurations, AC options, and travel packages. All our drivers are verified, and vehicles come with proper documentation and regular servicing for a worry-free journey. Great for local sightseeing and outstation adventures."
    },
    {
      "name": "Book Tempo Traveller Mumbai",
      "description": "Book your Tempo Traveller in Mumbai with Deva Cabs and enjoy seamless service and instant confirmation. We offer an easy online booking system, flexible rental hours, and multiple vehicle sizes. Whether for religious tours, weddings, or leisure trips, our well-maintained travellers and trained drivers ensure a comfortable journey every time."
    },
    {
      "name": "Traveller Bus on Rent in Mumbai",
      "description": "Need a mini-bus for your group? Deva Cabs offers Traveller buses on rent in Mumbai with seating options ranging from 12 to 26. These mini-buses are perfect for large family events, school/college trips, and intercity travel. Enjoy comfortable seats, AC, and a smooth ride backed by experienced support staff."
    },
    {
      "name": "17 Seater Minibus Hire in Mumbai",
      "description": "Hire a 17-seater minibus in Mumbai with Deva Cabs for your next event or journey. Ideal for mid-sized groups, our minibuses are spacious, safe, and equipped with AC, reclining seats, and storage space. From airport transfers to weekend getaways, our minibus rentals are reliable and cost-effective."
    },
    {
      "name": "17 Seater Bus on Rent in Mumbai",
      "description": "Deva Cabs provides 17-seater buses on rent in Mumbai for group tours, employee transport, and festive travel. Our buses feature large windows, clean interiors, and skilled drivers. We also provide on-route support and customizable travel itineraries to make your journey smooth and enjoyable."
    },
    {
      "name": "AC Tempo Traveller on Rent in Mumbai",
      "description": "Travel in comfort during Mumbai’s heat with our fully air-conditioned Tempo Travellers. Deva Cabs offers AC Tempo Traveller rentals for day tours, outstation trips, and corporate transport. Enjoy chilled cabins, comfortable seating, and reliable service at highly competitive rates across Mumbai and beyond."
    },
    {
      "name": "Mumbai to Mahabaleshwar Tempo Traveller on Rent",
      "description": "Planning a Mahabaleshwar trip from Mumbai? Hire a Tempo Traveller with Deva Cabs and enjoy a comfortable, safe ride with your group. Our drivers are familiar with hilly terrains, and our vehicles are perfect for scenic routes. Choose 12, 17, or 20-seaters based on your group size and travel with peace of mind."
    },
    {
      "name": "Mumbai to Goa Tempo Traveller on Rent",
      "description": "Headed to Goa from Mumbai with friends or family? Book a Tempo Traveller from Deva Cabs for a fun, convenient, and budget-friendly ride. With push-back seats, AC, and ample legroom, our Tempo Travellers make the long journey smooth and enjoyable. Perfect for beach holidays, group tours, and destination parties."
    },
    {
      "name": "Mumbai to Surat Tempo Traveller Fare",
      "description": "Get the best fare for your Mumbai to Surat Tempo Traveller ride with Deva Cabs. We offer competitive, all-inclusive pricing with no hidden charges. Choose from multiple vehicle sizes and enjoy a smooth highway ride with experienced drivers. Perfect for family functions, business travel, and bulk bookings."
    },
    {
      "name": "Mumbai to Shirdi Tempo Traveller on Rent",
      "description": "Deva Cabs offers Tempo Traveller rentals from Mumbai to Shirdi for religious trips and group pilgrimages. Our AC vehicles, comfortable seating, and knowledgeable drivers make your spiritual journey smooth and peaceful. Book 12 to 20-seaters with flexible timing and competitive pricing for Shirdi tours."
    },
    {
      "name": "Mumbai to Outstation Tempo Traveller",
      "description": "Planning an outstation trip from Mumbai? Deva Cabs provides Tempo Travellers for long-distance travel to Pune, Nashik, Lonavala, Goa, and more. All vehicles are fitted with GPS, AC, and comfortable seating. We offer both one-way and round-trip packages for families, tour groups, and corporate teams."
    },
    {
      "name": "Mumbai to Ashtavinayak Tempo Traveller Rental",
      "description": "Go on a spiritual journey across Maharashtra’s Ashtavinayak temples with Deva Cabs’ Tempo Traveller rentals. Our comfortable, AC vehicles and knowledgeable drivers ensure your group travels smoothly across all eight holy sites. Book complete travel packages or custom routes as per your plan."
    },
    {
      "name": "Mumbai to Tuljapur Tempo Traveller",
      "description": "Book a reliable Tempo Traveller from Mumbai to Tuljapur with Deva Cabs for a stress-free pilgrimage. Our vehicles are equipped with AC, music system, and reclining seats for long-distance comfort. Experienced drivers ensure safe and timely travel to Tulja Bhavani temple and surrounding areas."
    }
  ],
  "tableData": [
    ["Tempo Traveller on Rent in Mumbai", "-17-Seater Tempo Travellers on Rent in Mumbai"],
    ["Tempo on Rent Mumbai", "-20 Seater Tempo Travellers on Rent in Mumbai"],
    ["Hire Tempo Traveller in Mumbai", "-Book Tempo Traveller Mumbai"],
    ["Traveller Bus on Rent in Mumbai", "-17 Seater Minibus Hire in Mumbai"],
    ["17 Seater Bus on Rent in Mumbai", "-AC Tempo Traveller on Rent in Mumbai"],
    ["Mumbai to Mahabaleshwar Tempo Traveller on Rent", "-Mumbai to Goa Tempo Traveller on Rent"],
    ["Mumbai to Surat Tempo Traveller Fare", "-Mumbai to Shirdi Tempo Traveller on Rent"],
    ["Mumbai to Outstation Tempo Traveller", "-Mumbai to Ashtavinayak Tempo Traveller Rental"],
    ["Mumbai to Tuljapur Tempo Traveller", ""]
  ],

whychoose: [
  {
    "WhyChooseheading": "Spacious and Comfortable for Group Travel",
    "WhyChoosedescription": "Deva Cabs’ Tempo Travellers offer ample space to comfortably accommodate large groups, whether it’s for family outings, corporate events, or group tours in and around Mumbai. With ergonomic seating and plenty of legroom, every passenger enjoys a relaxed journey."
  },
  {
    "WhyChooseheading": "Ideal for Long-Distance and Outstation Trips",
    "WhyChoosedescription": "Our Tempo Travellers are well-maintained and equipped to handle long journeys smoothly. Whether you’re planning a weekend getaway, a pilgrimage, or an intercity tour, our vehicles provide a reliable and comfortable travel experience without the worry of breakdowns or delays."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "All our drivers are experienced in handling large vehicles and familiar with Mumbai’s traffic patterns and highways. They prioritize safety, punctuality, and customer comfort, ensuring your group arrives on time and stress-free."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Needs",
    "WhyChoosedescription": "We offer hourly, daily, and customized rental plans to match your specific itinerary. Whether you need the vehicle for a few hours within the city or multiple days for extensive travel, Deva Cabs provides flexible options to keep your plans affordable and hassle-free."
  },
  {
    "WhyChooseheading": "Modern Amenities for a Pleasant Ride",
    "WhyChoosedescription": "Our Tempo Travellers come equipped with air conditioning, ample storage space for luggage, comfortable seating, and clean interiors, ensuring a pleasant and enjoyable travel experience for every passenger."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "With Deva Cabs, you get competitive rates without hidden fees. Our transparent pricing model allows you to budget your trip confidently, with no surprises at the end of your journey."
  },
  {
    "WhyChooseheading": "24/7 Availability and Easy Booking",
    "WhyChoosedescription": "Whether it’s a last-minute group trip or a planned event, our Tempo Travellers are available round the clock. You can book easily through our website or customer support, ensuring seamless planning and execution."
  },
  {
    "WhyChooseheading": "Safe and Well-Maintained Vehicles",
    "WhyChoosedescription": "Safety is paramount for us. All Tempo Travellers undergo regular maintenance and safety checks, equipped with seat belts, GPS tracking, and clean interiors to guarantee a secure and comfortable journey."
  }
]




















    }










const faqData = [
  {
    question: "Can I rent a tempo traveller in Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers tempo traveller rentals in Mumbai for group travel, family outings, corporate events, and more."
  },
  {
    question: "What is the seating capacity of the tempo travellers available for rent?",
    answer: "Our tempo travellers typically seat between 9 to 15 passengers, making them ideal for medium to large groups."
  },
  {
    question: "Are the tempo travellers comfortable for long-distance travel?",
    answer: "Absolutely. Our tempo travellers are well-maintained, spacious, and equipped with comfortable seating to ensure a pleasant journey."
  },
  {
    question: "Can I hire a tempo traveller for outstation trips from Mumbai?",
    answer: "Yes, you can rent a tempo traveller for outstation travel from Mumbai to destinations like Lonavala, Pune, Nashik, and beyond."
  },
  {
    question: "Is a driver provided with the tempo traveller rental?",
    answer: "Yes, all tempo traveller rentals include a professional, experienced driver to ensure safe and smooth travel."
  },
  {
    question: "How do I book a tempo traveller on rent in Mumbai?",
    answer: "You can book a tempo traveller through our website, mobile app, or by calling our customer service team for personalized assistance."
  },
  {
    question: "What are the rental charges for tempo travellers in Mumbai?",
    answer: "Rental charges vary based on the duration, distance, and type of tempo traveller. Contact us for a detailed quote tailored to your requirements."
  },
  {
    question: "Can I rent a tempo traveller for sightseeing tours in and around Mumbai?",
    answer: "Yes, tempo travellers are perfect for sightseeing tours. We can arrange trips to popular destinations like Elephanta Caves, Lonavala, and more."
  },
  {
    question: "Are there any additional charges for waiting or extra kilometers?",
    answer: "Any additional charges such as waiting time or extra kilometers will be communicated upfront during booking to maintain transparency."
  },
  {
    question: "Why choose Deva Cabs for tempo traveller rental in Mumbai?",
    answer: "Deva Cabs provides well-maintained vehicles, professional drivers, flexible packages, and reliable service, making us the trusted choice for tempo traveller rentals in Mumbai."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    role: 'Family Traveler',
    review: 'We rented a tempo traveller from Deva Cabs for a family trip. The vehicle was spacious and comfortable, and the driver was very courteous. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Riya Desai',
    role: 'Event Organizer',
    review: 'Deva Cabs made our corporate outing smooth with their tempo traveller rental service. Professional driver and well-maintained vehicle. Will book again.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Mumbai",
  "image": "https://devacab.com/assets/images/tempo-traveller-on-rent-mumbai.jpg", // Replace with actual image URL
  "description": "Rent luxury and affordable Tempo Travellers in Mumbai with Deva Cabs. Available in 9, 12, and 17-seater options with AC and driver for outstation trips, weddings, family outings, corporate travel, and group tours.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8000",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/tempo-traveller-on-rent-in-mumbai" // Replace with actual page URL
  }
};



    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Tempo Traveller on Rent in Mumbai | 9, 12 & 17 Seater Tempo Hire | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Tempo Traveller on rent in Mumbai with Deva Cabs. Choose from 9, 12, and 17-seater AC tempo travellers with driver for weddings, outstation trips, corporate travel, family tours, and group travel." 
  />
  <meta 
    name="keywords" 
    content="Tempo Traveller on Rent in Mumbai, 9 seater tempo hire Mumbai, 12 seater tempo traveller Mumbai, 17 seater tempo traveller Mumbai, Luxury tempo traveller Mumbai, AC tempo traveller rental Mumbai, Tempo for outstation Mumbai, Tempo traveller for wedding Mumbai, Family trip tempo traveller Mumbai, Tempo with driver Mumbai, Corporate tempo traveller Mumbai, Tourist tempo traveller hire Mumbai, Tempo traveller for Shirdi from Mumbai, Mumbai to Pune tempo traveller, Tempo traveller for group travel Mumbai, Affordable tempo hire Mumbai, Online tempo traveller booking Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default TempoTravelleronrentmumbai;